import styled from 'styled-components';
import { Flex, FlexProps } from '@mantine/core';

export const StyledFormWrapper = styled(Flex)<FlexProps>`
	flex: 1;
	border-right: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};

	form .fields-wrapper {
		flex-direction: row;
		flex-wrap: wrap;

		div.mantine-InputWrapper-root {
			width: calc(50% - 0.25rem);
		}
	}
`;
